export const CriarDashboardPersonalizada = 'CriarDashboardPersonalizada';
export const RemoverDashboardPersonalizada = 'RemoverDashboardPersonalizada';
export const ModificarDashboardPersonalizada = 'ModificarDashboardPersonalizada';
export const AlternarEntreDashboardPersonalizadas = 'AlternarEntreDashboardPersonalizadas';
export const ModificarFiltroLocalWidgetsDashboard = 'ModificarFiltroLocalWidgetsDashboard';
